<video-playback-overlay-dialog [headerText]="'Media_Videos_Preposition_TabTitle' | translate">
	<div slot="headerActions">
		<button type="button" class="margin-right-5" (click)="onCancel()" [disabled]="isSaving" vbBtnSecondary>
			{{ 'Cancel' | translate }}
		</button>

		<button type="button" (click)="onSave()" [disabled]="prepositionForm.invalid || isSaving" vbBtnPrimary>
			{{ 'Save' | translate }}
		</button>
	</div>

	<div slot="content">
		<vb-loading-spinner *ngIf="isSaving" [size]="'medium'">
		</vb-loading-spinner>

		<form name="prepositionForm" #prepositionForm="ngForm" [ngClass]="styles.prepositionForm" [hidden]="isSaving" (submit)="onSave()">
			<vb-ui-form-group>
				<label for="dateTimePicker" #uiLabel>{{ 'Event_Start' | translate }}</label>
				<vb-date-time-picker uiControl name="dateTimePicker" [(ngModel)]="scheduleDateTime" #dtPicker="ngModel" [accessibilityLabel]="'Event_Start' | translate" [timezoneId]="scheduleTimezoneId" [vbMin]="today" required>
				</vb-date-time-picker>
				<div *ngIf="dtPicker.invalid" role="alert" vbUiErrorMessage uiValidation>
					<div *ngIf="dtPicker.errors.required">
						{{ 'ThisFieldIsRequired' | translate }}
					</div>
					<div *ngIf="dtPicker.errors.date">
						{{ 'Event_InvalidDate' | translate : { '0' : (exampleTime | vbFormatDate : 'LL')} }}
					</div>
					<div *ngIf="dtPicker.errors.time">
						{{ 'Event_InvalidTime' | translate : { '0' : (exampleTime | vbFormatDate : 'LT')} }}
					</div>
					<div *ngIf="dtPicker.errors.vbMin">
						{{ 'Event_MinDateToday' | translate }}
					</div>
				</div>
			</vb-ui-form-group>

			<vb-ui-form-group>
				<label for="prepositionTimezone" #uiLabel>{{ 'Event_Timezone' | translate }}</label>
				<vb-ui-select uiControl>
					<select name="prepositionTimezone" id="prepositionTimezone" [(ngModel)]="scheduleTimezoneId" #selectElement #prepositionTimezone="ngModel">
						<option [ngValue]="undefined">{{ 'Event_TimezoneDefault' | translate }}</option>
						<option *ngFor="let timezone of TimezoneCodes" [ngValue]="timezone.id">{{ timezone.name }}</option>
					</select>
				</vb-ui-select>
			</vb-ui-form-group>
		</form>
	</div>
</video-playback-overlay-dialog>
